import { createFileRoute } from "@tanstack/react-router";
import PsychotherapyPage from "@/pages/PsychotherapyPage";
export const Route = createFileRoute("/services/psychotherapy")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Psychotherapy Coral Springs | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Individual, couples, and family psychotherapy in Coral Springs, FL. Licensed therapists offering CBT, DBT, EMDR, and Ketamine-Assisted Psychotherapy for.",
        },
        {
          property: "og:title",
          content: "Psychotherapy Coral Springs | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Individual, couples, and family psychotherapy in Coral Springs, FL. Licensed therapists offering CBT, DBT, EMDR, and Ketamine-Assisted Psychotherapy for.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/services/psychotherapy",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/services/psychotherapy",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <PsychotherapyPage />;
}
